import React from 'react';
import { IconGames } from 'components/icons/icon-games/icon-games';

export const GameCardStub = () => (
  <div className="game-card game-card-stub">
    <IconGames className="game-card-stub-icon position-absolute" />
  </div>
);
